import _defineProperty from "@babel/runtime/helpers/defineProperty";
//
// Copyright IBM Corp. 2022
//
// This source code is licensed under the Apache-2.0 license found in the
// LICENSE file in the root directory of this source tree.
//
import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'carbon-components-react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { pkg } from '../../settings';
var blockClass = "".concat(pkg.prefix, "--add-select__breadcrumbs");
var componentName = 'AddSelectBreadcrumbs';
export var AddSelectBreadcrumbs = function AddSelectBreadcrumbs(_ref) {
  var multi = _ref.multi,
      onClick = _ref.onClick,
      path = _ref.path;

  var clickHandler = function clickHandler(idx) {
    onClick(idx);
  };

  var classNames = cx(blockClass, _defineProperty({}, "".concat(blockClass, "-multi"), multi));
  return /*#__PURE__*/React.createElement(Breadcrumb, {
    noTrailingSlash: true,
    className: classNames
  }, path.map(function (entry, idx) {
    var isCurrentPage = idx === path.length - 1;
    return /*#__PURE__*/React.createElement(BreadcrumbItem, {
      key: entry.id,
      isCurrentPage: isCurrentPage,
      onClick: function onClick() {
        return clickHandler(idx);
      }
    }, entry.title);
  }));
};
AddSelectBreadcrumbs.propTypes = {
  multi: PropTypes.bool,
  onClick: PropTypes.func,
  path: PropTypes.array
};
AddSelectBreadcrumbs.displayName = componentName;